import { Box, Flex, Text } from "@nulogy/components";
import React from "react";
import Time from "utils/Time";

export default function LineTooltip({ record }) {
  const {
    data: { plannedBreaks: plannedBreaksForLine },
  } = record;

  return (
    <Flex flexDirection="column" gap="x1" padding="0">
      {plannedBreaksForLine.length === 0 ? (
        <Text fontSize="smaller" width="120px">
          Planned breaks have not been configured for this line.
        </Text>
      ) : (
        <>
          <Text fontSize="small" fontWeight="medium" lineHeight="smallTextCompressed">
            Planned breaks
          </Text>
          {plannedBreaksForLine.map((plannedBreak) => {
            const formattedTimespan = `${Time.to12Hour(plannedBreak.startTime)} - ${Time.to12Hour(plannedBreak.endTime)}`;

            return (
              <Box key={plannedBreak.id}>
                <Text fontSize="smaller" fontWeight="medium" style={{ overflowWrap: "break-word" }}>
                  {plannedBreak.name}
                </Text>
                <Text fontSize="smaller">{Time.formattedDays(plannedBreak)}</Text>
                <Text fontSize="smaller">{formattedTimespan}</Text>
              </Box>
            );
          })}
        </>
      )}
    </Flex>
  );
}
